module.exports = __webpack_public_path__ + "img/logo_plateform.30916fda.jpg";